import {
  transformButtonVariant,
  transformFontWeight,
  transformLinkTarget,
  transformResponsiveDYNumbersVariable,
} from '../utils';
import { DyMessageBannerData } from './DYMessageBanner';
import { MessageBannerProps } from './MessageBanner';

export function transformDYTemplateVariables(
  dyTemplateVariables: DyMessageBannerData,
): Omit<MessageBannerProps, 'onClick'> {
  const { text, fontSize, fontWeight, backgroundColor, fontColor, button } = dyTemplateVariables;
  return {
    text,
    fontSize: transformResponsiveDYNumbersVariable(fontSize),
    fontWeight: transformFontWeight(fontWeight),
    backgroundColor,
    fontColor,
    button: button?.text
      ? {
          text: button.text,
          variant: transformButtonVariant(button.variant),
          linkUrl: button.linkUrl,
          linkTarget: transformLinkTarget(button.linkTarget),
        }
      : undefined,
  };
}
